export default "__VITE_ASSET__PJAV8nua__"